import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AnalyticsEvent } from 'src/app/core/enums/AnalyticsEvent';
import { SocialShareIcon } from 'src/app/core/enums/SocialShareIcon';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.scss'],
})
export class SocialShareComponent implements OnInit {
  @Input() url?: string;
  @Input() title?: string;
  @Input() description?: string;
  @Input() imageUrl?: string;
  @Input() include?: SocialShareIcon[] = [];
  @Output() onClickAction = new EventEmitter();

  name = 'ngx sharebuttons';
  socialShareIcons = SocialShareIcon;
  socialShareIcon: any[] = [];
  copiedText: boolean = false;

  constructor(
    private analyticsService: AnalyticsService,
    private clipboard: Clipboard,
  ) { }

  ngOnInit(): void {
    if (this.include.length === 0) {
      this.socialShareIcon = Object.keys(this.socialShareIcons).map(key => this.socialShareIcons[key]);
    } else {
      this.socialShareIcon = this.include;
    }
  }

  iconImage(icon: SocialShareIcon) {
    switch (icon) {
      case this.socialShareIcons.facebook:
        return "assets/social-media-icon/facebook.png";
      case this.socialShareIcons.messenger:
        return "assets/social-media-icon/messenger.png";
      case this.socialShareIcons.whatsapp:
        return "assets/social-media-icon/whatsapp.png";
      case this.socialShareIcons.email:
        return "assets/social-media-icon/email.png";
      default:
        return "";
    }
  }

  shareReferral(event: any) {
    this.analyticsService.logEvents(AnalyticsEvent.share, {
      content_type: 'referral code',
      item_id: '',
      method: 'web'
    });
  }

  onCopyURL() {
    if (this.url) {
      this.copiedText = this.clipboard.copy(this.url);
      this.copiedText = true;
      setTimeout(() => {
        this.copiedText = false;
      }, 1500);
    }
  }

  onClickClose(){
    this.onClickAction.emit();
  }
}
